module.exports = "/_next/static/images/img__card-1-desktop-82d9c960977513273b6c2325581f5eb7.png";